module.exports = __webpack_public_path__ + "img/case2.a224267a.jpg";